import { useEffect } from "react";
import { Fragment } from "react";
import { useQuery } from "@tanstack/react-query";

import { teamCompareQueryOptions } from "@/api/teamCompare";
import { useSelectedMatch } from "@/context/matchContext";
import { useSelectedTeam } from "@/context/teamContext";
import { useDashboardComparison } from "../page";
import { Loader } from "@/components/general/common/loader";
import { TeamStatsPanel } from "@/components/general/Dashboard/TeamStatsPanel";
import { CombinedPlayersTable } from "@/components/general/Dashboard/CombinedPlayersTable";

export const TeamComparisonPage = () => {
    const { matchIds, setTournamentName } = useSelectedMatch();
    const { setSelectedPlayers: setContextSelectedPlayers } = useDashboardComparison();
    const { teamId } = useSelectedTeam();

    const { data: teamCompareData, isLoading } = useQuery(
        teamCompareQueryOptions(matchIds.length > 0 ? matchIds : [], teamId)
    );

    useEffect(() => {
        if (teamCompareData && teamCompareData.length > 0) {
            setTournamentName("Tournament");
        }
    }, [teamCompareData, setTournamentName]);

    useEffect(() => {
        setContextSelectedPlayers([]);
    }, [setContextSelectedPlayers]);

    if (isLoading) {
        return (
            <div className="flex flex-col min-h-0 h-[755px]">
                <div className="flex flex-col gap-4 flex-1 min-h-0">
                    <div className="glass card rounded-xl p-6 flex items-center justify-center flex-1">
                        <Loader message="Loading team comparison..." />
                    </div>
                </div>
            </div>
        );
    }

    if (!teamCompareData || teamCompareData.length === 0) {
        return (
            <section className="flex flex-col h-full overflow-hidden">
                <div className="flex flex-1 flex-col gap-4 overflow-hidden h-full">
                    <div className="flex-1 flex flex-col gap-4 p-3 border border-table-border rounded-md h-full overflow-hidden bg-comparison-bg min-h-0">
                        <div className="flex items-center justify-center h-full">
                            <span className="text-center p-4 text-on-surface-variant">
                                No team comparison data available
                            </span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (teamCompareData && matchIds.length > 1) {
        return (
            <section className="flex flex-col h-full overflow-hidden">
                <div className="flex flex-1 flex-col gap-4 overflow-hidden h-full">
                    <div className="flex-1 flex flex-col gap-4 p-3 border border-table-border rounded-md h-full overflow-hidden bg-comparison-bg min-h-0">
                        <div className="flex items-center justify-center h-full">
                            <span className="text-center p-4 text-on-surface-variant">
                                This view works only with 1 match selected for team comparison
                            </span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="flex flex-col h-full overflow-auto">
            <div className="grid grid-cols-1 lg:grid-cols-[repeat(auto-fit,minmax(440px,1fr))] gap-4">
                {teamCompareData.map((matchData) => (
                    <Fragment key={matchData.matchId}>
                        <div id="onboarding-team-kpi">
                            <TeamStatsPanel chosenInfo={matchData.chosenInfo} opponentInfo={matchData.opponentInfo} />
                        </div>
                        <div id="onboarding-team-players">
                            <CombinedPlayersTable
                                chosenInfo={matchData.chosenInfo}
                                opponentInfo={matchData.opponentInfo}
                            />
                        </div>
                    </Fragment>
                ))}
            </div>
        </section>
    );
};
